import { render, staticRenderFns } from "./dashboardTestingStatusTable.vue?vue&type=template&id=9620bef4"
import script from "./dashboardTestingStatusTable.vue?vue&type=script&lang=js"
export * from "./dashboardTestingStatusTable.vue?vue&type=script&lang=js"
import style0 from "./dashboardTestingStatusTable.vue?vue&type=style&index=0&id=9620bef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports